import { render, staticRenderFns } from "./NhstCorporateRegistration.vue?vue&type=template&id=73979242&scoped=true"
import script from "./NhstCorporateRegistration.vue?vue&type=script&lang=js"
export * from "./NhstCorporateRegistration.vue?vue&type=script&lang=js"
import style0 from "./NhstCorporateRegistration.vue?vue&type=style&index=0&id=73979242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73979242",
  null
  
)

export default component.exports